import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import ConditionStatusChip from '../ConditionStatusChip';

import { wrapperStyles } from './StatusCell.styles';
import { getSignedOffMetaLabel } from './StatusCell.utils';

const StatusCell = ({ status, signedOffBy, signedOffDate }) => {
  const signedOffMeta = getSignedOffMetaLabel({ signedOffBy, signedOffDate });

  return (
    <Box sx={wrapperStyles}>
      <ConditionStatusChip status={status} />
      {signedOffMeta && (
        <Typography color="text.secondary" variant="regular12">
          {signedOffMeta}
        </Typography>
      )}
    </Box>
  );
};

StatusCell.propTypes = {
  status: PropTypes.string.isRequired,
  signedOffBy: PropTypes.string,
  signedOffDate: PropTypes.string,
};

export default memo(StatusCell);
